<template>
  <div id="pbn-filters">
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select
          placeholder="Clients"
          v-if="this.f.clients && this.f.clients.length"
          v-model="multiFilters['clients']"
          :options="this.f.clients.concat([{id: 'null', name: 'No Client'}])"
          :reduce="client => client.id"
          label="name"
          multiple="multiple"
          @change="search"
        >
        </v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Order" v-model="multiFilters['orders']" :options="this.f.orders" label="fullName" multiple="multiple"
                  @change="search">
        </v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Group" v-model="multiFilters['groups']" :options="this.f.groups" label="fullName" multiple="multiple"
                  @change="search">
        </v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select
          placeholder="Priority"
          v-model="filters['priority']"
          :options="priorities"
          index="id"
          multiple="multiple"
          @change="search"
        >
        </v-select>
      </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Status" v-model="filters['buildStatus']" :options="buildStatuses" multiple="multiple" index="id" @change="search">
        </v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Has IP" v-model="filters['hasIp']" :options="[{index: 1, label: 'Yes'}, {index: 0, label: 'No'}, {index: null, label: 'Both'}]" index="index" @change="search">
        </v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="IP matches" v-model="filters['ipMatches']" :options="[{index: 1, label: 'Yes'}, {index: 0, label: 'No'}, {index: null, label: 'Both'}]" index="index" @change="search">
        </v-select>
      </div>
    </div>
    <div class="search col-lg-12 col-md-12 m-t-sm">
      <div class="col-lg-3">
        <button class="btn btn-xs btn-primary" @click="search">Search</button>
      </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="row col-lg-12 col-md-12 m-t-md">
        Showing <b>{{ meta.count }}</b> of <b>{{ meta.resultCount }}</b> results
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { Browser } from '../../../../mixins/helperMixin'
import { PBNS_SET } from '../../../../store/mutation-types'
import { eventBus } from '../../../../main'

export default {
  data () {
    return {
      filters: {
      },
      meta: {
        count: 0,
        resultCount: 0
      },
      priorities: [
        {
          label: 'Low',
          id: 1
        },
        {
          label: 'Normal',
          id: 2
        },
        {
          label: 'High',
          id: 3
        }
      ],
      multiFilters: {},
      actionFilters: {},
      stats: {},
      buildStatuses: [
        {
          label: 'Waiting Build',
          id: 'waiting-build'
        },
        {
          label: 'Building',
          id: 'building'
        },
        {
          label: 'Built',
          id: 'built'
        },
        {
          label: 'Missing Content',
          id: 'missing-content'
        },
        {
          label: 'Waiting Prod Move',
          id: 'waiting-prod-move'
        },
        {
          label: 'Content to be Added',
          id: 'waiting-content-added'
        },
        {
          label: 'Delivered',
          id: 'delivered'
        },
        {
          label: 'Waiting QA',
          id: 'waiting-qa'
        },
        {
          label: 'Waiting Domain Move',
          id: 'waiting-domain-move'
        },
        {
          label: 'Unassigned',
          id: 'unassigned'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }

    eventBus.$on('searchBuilds', () => {
      this.search()
    })
  },
  methods: {
    search (e, type = null) {
      axios.get('/pbn/list?' + this.buildQuery(), {
        headers: {
          'Accept': type === 'csv' ? 'text/csv' : 'application/json'
        }
      }).then(r => {
        if (type === 'csv') {
          Browser.methods.downloadFile('build-list.csv', r.data.data)
        } else {
          this.$store.commit(PBNS_SET, r.data.data)
          this.meta = r.data.meta
        }
      }).catch(e => {
        this.$toastr.error(e, 'Whoopsy Daisy')
      })
    },
    buildQuery () {
      let filters = {}
      Object.entries(this.multiFilters).forEach((data) => {
        filters[data[0]] = data[1].map(c => c.id)
      })

      let query = 'buildFlow=true'
      query += '&' + Object.keys(filters).map(key => `${key}=${filters[key]}`).join('&')
      query += '&' + Object.keys(this.filters).map(key => `${key}=${this.filters[key]}`).join('&')
      query += '&' + Object.keys(this.stats).map(key => `stats[${key}]=${this.stats[key]}`).join('&')
      return query
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/Filters.vue